import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FreightLocationActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Freight/FreightLocation/FreightLocationBrowser")
	}

	render() {
		return (
			<Activity 
				name="FreightLocation"
				RenderedComponent={this.RenderedComponent}
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FreightLocationActivity)